import * as Model from "@effect/sql/Model";
import { Schema } from "effect";

/**
 * The direction of a wake tick: the walk `parked`, or it `woke`.
 *
 * @since 1.0.0
 */
export const LoopWakeKind = Schema.Literal("parked", "woke");
export type LoopWakeKind = Schema.Schema.Type<typeof LoopWakeKind>;

/**
 * Loop wake model — one park or wake tick of a loop invocation, the durable
 * row the viewer's timeline reads.
 *
 * `at` is the interpreter's logical clock in milliseconds — a `Number` here, a
 * `bigint` in the column — as is `dueAt`, the instant a `"parked"` tick means
 * to be back (`null` when it parks on the recheck interval instead).
 * `customerId` / `invocationId` are by id only.
 *
 * @since 1.0.0
 */
export class LoopWake extends Model.Class<LoopWake>("LoopWake")({
  id: Model.Generated(Schema.String),

  customerId: Schema.String,

  invocationId: Schema.String,

  kind: LoopWakeKind,

  parkSeq: Schema.Number,
  stateSeq: Schema.Number,

  reason: Schema.String,

  dueAt: Schema.NullOr(Schema.Number),
  detail: Schema.NullOr(Schema.Unknown),

  at: Schema.Number,

  createdAt: Model.DateTimeInsertFromDate,
}) {}
